import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { booneConfig } from "./data";

export default function BoonePage() {
  return <CityPageTemplate config={booneConfig} />;
}